/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_AllocatableInputs */

const en_admin_resource_form_allocatable = /** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocatable`)
};

const de_admin_resource_form_allocatable = /** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisbar`)
};

const es_admin_resource_form_allocatable = /** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignable`)
};

const fr_admin_resource_form_allocatable = /** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribuable`)
};

/** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */
const it_admin_resource_form_allocatable = en_admin_resource_form_allocatable;

/** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */
const pt_br2_admin_resource_form_allocatable = en_admin_resource_form_allocatable;

/** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */
const pl_admin_resource_form_allocatable = en_admin_resource_form_allocatable;

/** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */
const hu_admin_resource_form_allocatable = en_admin_resource_form_allocatable;

/** @type {(inputs: Admin_Resource_Form_AllocatableInputs) => LocalizedString} */
const ro_admin_resource_form_allocatable = en_admin_resource_form_allocatable;

/**
* | output |
* | --- |
* | "Allocatable" |
*
* @param {Admin_Resource_Form_AllocatableInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_allocatable = /** @type {((inputs?: Admin_Resource_Form_AllocatableInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_AllocatableInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_allocatable(inputs)
	if (locale === "de") return de_admin_resource_form_allocatable(inputs)
	if (locale === "es") return es_admin_resource_form_allocatable(inputs)
	if (locale === "fr") return fr_admin_resource_form_allocatable(inputs)
	if (locale === "it") return it_admin_resource_form_allocatable(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_allocatable(inputs)
	if (locale === "pl") return pl_admin_resource_form_allocatable(inputs)
	if (locale === "hu") return hu_admin_resource_form_allocatable(inputs)
	return ro_admin_resource_form_allocatable(inputs)
});
export { admin_resource_form_allocatable as "admin.resource_form.allocatable" }